module.exports = __webpack_public_path__ + "static/media/python-01.6369a07c.png";